module.exports = __webpack_public_path__ + "img/kamnev.fd6e479c.png";